<div *ngIf="multistageConfig" [ngStyle]="getGridListStyle" class="tile-container">
    <div *ngFor="let map of multistageConfig.maps;  index as i; trackBy: trackByIdentity;" [style.minHeight.px]="'198.5'"
         [style.minWidth.px]="'198.5'" class="tile">
        <ng-container *ngIf="isMapValorized(map); else emptyCard">
            <anatomic-map
                #anatomicMap
                (dataUpdated)="onDataUpdated($event,map)"
                (selectionEvent)="onSelectionEvent($event, map,i)"
                [currentColor]="currentColor"
                [data]="findColorDataByStageID(map.stageID)?.colorData"
                [externalSegmentSelected]="selectedSegmentForStage(map)"
                [hasTooltips]="true"
                [isMapSelected]="_isThisMapSelected(map)"
                [isWithStageName]="isWithStageName"
                [isWithViewId]="isWithViewId"
                [lowerLabel]="viewBottomLabelFromMap(map)"
                [map]="map"
                [readOnly]="readOnly"
                [segmentLabel]="segmentLabelType"
                [upperLabel]="viewUpperLabelFromMap(map)"
                [viewSideLenght]="viewsSideLenght"
            ></anatomic-map>
        </ng-container>
        <ng-template #emptyCard>
            <div class="empty-card">
                <div class="empty-map mat-elevation-z1"></div>
            </div>
        </ng-template>
    </div>
</div>
<div class="buttons-container">
    <map-legend (buttonClicked)="onLegendBtnClick($event)"
                (colorChanged)="onLegendSelection($event)"
                *ngIf="_legendButton.length > 0"
                [actualColor]="currentColor"
                [buttonsConfiguration]="buttonsConf"
                [isHorizontal]="isHorizontal"
                [legend]="legendColors"
                [ngStyle]="getLegendStyle"
                [readOnly]="readOnly"
    >
    </map-legend>
    <ng-content extra-buttons-before select="[extra-buttons-legend]"></ng-content>
    <button (click)="onCopyFromPrevious()" *ngIf="_multistage.length > 0"
            [anatomicMapTooltip]="'copia dal precedente'"
            [disabled]="readOnly" class="mat-button-like copy-from-previous">content_copy
    </button>
</div>
